export const colorBackgroundAccentPrimary = "rgb(240, 247, 250)";
export const colorBackgroundAccentPrimaryTurva = "rgb(253, 247, 242)";
export const colorBackgroundAccentSecondary = "rgb(228, 241, 247)";
export const colorBackgroundAccentSecondaryTurva = "rgb(251, 235, 225)";
export const colorBackgroundAccentTertiary = "rgb(0, 119, 179)";
export const colorBackgroundAccentTertiaryTurva = "rgb(230, 23, 64)";
export const colorBackgroundPrimary = "rgb(255, 255, 255)";
export const colorBackgroundPrimaryTurva = "rgb(255, 255, 255)";
export const colorBackgroundSecondary = "rgb(245, 248, 250)";
export const colorBackgroundSecondaryTurva = "rgb(245, 246, 247)";
export const colorBackgroundTertiary = "rgb(8, 42, 77)";
export const colorBackgroundTertiaryTurva = "rgb(23, 42, 59)";
export const colorBrandBlue = "rgb(0, 161, 212)";
export const colorBrandGrayTurva = "rgb(178, 180, 179)";
export const colorCategoryFamily = "rgb(11, 114, 136)";
export const colorCategoryFamilyTurva = "rgb(199, 12, 112)";
export const colorCategoryFinance = "rgb(122, 1, 196)";
export const colorCategoryHome = "rgb(211, 36, 131)";
export const colorCategoryHomeTurva = "rgb(161, 10, 78)";
export const colorCategoryPet = "rgb(168, 1, 78)";
export const colorCategoryTravel = "rgb(213, 66, 3)";
export const colorCategoryTravelTurva = "rgb(9, 129, 148)";
export const colorCategoryUnionTurva = "rgb(169, 69, 124)";
export const colorCategoryVehicle = "rgb(54, 74, 129)";
export const colorCategoryVehicleTurva = "rgb(23, 28, 58)";
export const colorDanger = "rgb(214, 28, 82)";
export const colorDanger00 = "rgb(255, 240, 243)";
export const colorDanger100 = "rgb(255, 211, 219)";
export const colorDanger1000 = "rgb(89, 0, 45)";
export const colorDanger200 = "rgb(255, 173, 190)";
export const colorDanger300 = "rgb(252, 136, 162)";
export const colorDanger400 = "rgb(243, 98, 134)";
export const colorDanger50 = "rgb(255, 225, 231)";
export const colorDanger500 = "rgb(231, 62, 107)";
export const colorDanger600 = "rgb(214, 28, 82)";
export const colorDanger700 = "rgb(185, 16, 74)";
export const colorDanger800 = "rgb(153, 9, 66)";
export const colorDanger900 = "rgb(120, 4, 56)";
export const colorDangerTurva = "rgb(214, 28, 82)";
export const colorData01 = "rgb(122, 1, 196)";
export const colorData02 = "rgb(0, 155, 204)";
export const colorData03 = "rgb(27, 171, 75)";
export const colorData04 = "rgb(255, 86, 34)";
export const colorData05 = "rgb(245, 76, 154)";
export const colorData06 = "rgb(194, 21, 101)";
export const colorData07 = "rgb(192, 101, 247)";
export const colorData08 = "rgb(0, 105, 191)";
export const colorData09 = "rgb(19, 120, 53)";
export const colorData10 = "rgb(179, 60, 24)";
export const colorData11 = "rgb(13, 163, 166)";
export const colorData12 = "rgb(11, 114, 136)";
export const colorData13 = "rgb(179, 137, 24)";
export const colorData14 = "rgb(128, 98, 17)";
export const colorData15 = "rgb(0, 41, 77)";
export const colorGray = "rgb(181, 198, 208)";
export const colorGrayDark = "rgb(127, 150, 165)";
export const colorGrayDarkTurva = "rgb(143, 147, 158)";
export const colorGrayDarker = "rgb(98, 121, 138)";
export const colorGrayDarkerTurva = "rgb(113, 118, 132)";
export const colorGrayLight = "rgb(212, 223, 229)";
export const colorGrayLightTurva = "rgb(222, 224, 228)";
export const colorGrayLighter = "rgb(245, 248, 250)";
export const colorGrayLighterTurva = "rgb(245, 247, 250)";
export const colorGrayLightest = "rgb(255, 255, 255)";
export const colorGrayLightestTurva = "rgb(255, 255, 255)";
export const colorGrayTurva = "rgb(199, 202, 207)";
export const colorLtBlue00 = "rgb(240, 247, 250)";
export const colorLtBlue100 = "rgb(217, 236, 245)";
export const colorLtBlue1000 = "rgb(8, 42, 77)";
export const colorLtBlue200 = "rgb(198, 225, 238)";
export const colorLtBlue300 = "rgb(172, 210, 229)";
export const colorLtBlue400 = "rgb(131, 188, 217)";
export const colorLtBlue50 = "rgb(228, 241, 247)";
export const colorLtBlue500 = "rgb(50, 153, 204)";
export const colorLtBlue600 = "rgb(0, 119, 179)";
export const colorLtBlue700 = "rgb(0, 97, 155)";
export const colorLtBlue800 = "rgb(0, 75, 129)";
export const colorLtBlue900 = "rgb(3, 56, 102)";
export const colorLtGray00 = "rgb(245, 248, 250)";
export const colorLtGray100 = "rgb(212, 223, 229)";
export const colorLtGray1000 = "rgb(17, 28, 38)";
export const colorLtGray200 = "rgb(181, 198, 208)";
export const colorLtGray300 = "rgb(153, 174, 186)";
export const colorLtGray400 = "rgb(127, 150, 165)";
export const colorLtGray50 = "rgb(228, 236, 239)";
export const colorLtGray500 = "rgb(98, 121, 138)";
export const colorLtGray600 = "rgb(81, 105, 123)";
export const colorLtGray700 = "rgb(62, 84, 102)";
export const colorLtGray800 = "rgb(45, 64, 81)";
export const colorLtGray900 = "rgb(30, 45, 59)";
export const colorPartnerBrandSGroup = "rgb(0, 170, 70)";
export const colorPrimary = "rgb(0, 119, 179)";
export const colorPrimaryDark = "rgb(0, 75, 129)";
export const colorPrimaryDarkTurva = "rgb(126, 2, 35)";
export const colorPrimaryDarker = "rgb(0, 97, 155)";
export const colorPrimaryDarkerTurva = "rgb(164, 4, 40)";
export const colorPrimaryLight = "rgb(198, 225, 238)";
export const colorPrimaryLightTurva = "rgb(255, 185, 190)";
export const colorPrimaryLighter = "rgb(228, 241, 247)";
export const colorPrimaryLighterTurva = "rgb(255, 227, 228)";
export const colorPrimaryLightest = "rgb(240, 247, 250)";
export const colorPrimaryLightestTurva = "rgb(255, 241, 241)";
export const colorPrimaryTurva = "rgb(198, 12, 48)";
export const colorSecondary = "rgb(8, 42, 77)";
export const colorSecondaryTurva = "rgb(23, 28, 58)";
export const colorSuccess = "rgb(48, 131, 105)";
export const colorSuccess00 = "rgb(244, 250, 247)";
export const colorSuccess100 = "rgb(218, 246, 233)";
export const colorSuccess1000 = "rgb(4, 38, 33)";
export const colorSuccess200 = "rgb(191, 239, 218)";
export const colorSuccess300 = "rgb(163, 229, 202)";
export const colorSuccess400 = "rgb(134, 215, 185)";
export const colorSuccess50 = "rgb(231, 248, 239)";
export const colorSuccess500 = "rgb(105, 196, 166)";
export const colorSuccess600 = "rgb(76, 164, 138)";
export const colorSuccess700 = "rgb(48, 131, 105)";
export const colorSuccess800 = "rgb(29, 106, 88)";
export const colorSuccess900 = "rgb(13, 71, 59)";
export const colorSuccessTurva = "rgb(48, 131, 105)";
export const colorTurva2Gray00 = "rgb(245, 246, 247)";
export const colorTurva2Gray100 = "rgb(212, 221, 226)";
export const colorTurva2Gray1000 = "rgb(6, 23, 38)";
export const colorTurva2Gray200 = "rgb(178, 194, 205)";
export const colorTurva2Gray300 = "rgb(148, 169, 185)";
export const colorTurva2Gray400 = "rgb(120, 145, 164)";
export const colorTurva2Gray50 = "rgb(228, 233, 237)";
export const colorTurva2Gray500 = "rgb(95, 122, 143)";
export const colorTurva2Gray600 = "rgb(72, 100, 122)";
export const colorTurva2Gray700 = "rgb(53, 79, 101)";
export const colorTurva2Gray800 = "rgb(37, 60, 80)";
export const colorTurva2Gray900 = "rgb(23, 42, 59)";
export const colorTurva2Red00 = "rgb(255, 242, 242)";
export const colorTurva2Red100 = "rgb(255, 229, 230)";
export const colorTurva2Red1000 = "rgb(51, 0, 10)";
export const colorTurva2Red200 = "rgb(255, 201, 204)";
export const colorTurva2Red300 = "rgb(249, 164, 172)";
export const colorTurva2Red400 = "rgb(243, 119, 133)";
export const colorTurva2Red50 = "rgb(255, 236, 236)";
export const colorTurva2Red500 = "rgb(236, 69, 96)";
export const colorTurva2Red600 = "rgb(230, 23, 64)";
export const colorTurva2Red700 = "rgb(185, 3, 41)";
export const colorTurva2Red800 = "rgb(140, 0, 30)";
export const colorTurva2Red900 = "rgb(96, 0, 20)";
export const colorTurvaGray00 = "rgb(245, 247, 250)";
export const colorTurvaGray100 = "rgb(222, 224, 228)";
export const colorTurvaGray1000 = "rgb(8, 13, 38)";
export const colorTurvaGray200 = "rgb(199, 202, 207)";
export const colorTurvaGray300 = "rgb(175, 178, 186)";
export const colorTurvaGray400 = "rgb(143, 147, 158)";
export const colorTurvaGray50 = "rgb(234, 235, 239)";
export const colorTurvaGray500 = "rgb(113, 118, 132)";
export const colorTurvaGray600 = "rgb(98, 104, 122)";
export const colorTurvaGray700 = "rgb(71, 78, 101)";
export const colorTurvaGray800 = "rgb(45, 52, 79)";
export const colorTurvaGray900 = "rgb(23, 28, 58)";
export const colorTurvaNude00 = "rgb(253, 247, 242)";
export const colorTurvaNude100 = "rgb(251, 225, 209)";
export const colorTurvaNude1000 = "rgb(38, 21, 15)";
export const colorTurvaNude200 = "rgb(241, 202, 178)";
export const colorTurvaNude300 = "rgb(216, 174, 150)";
export const colorTurvaNude400 = "rgb(190, 147, 124)";
export const colorTurvaNude50 = "rgb(251, 235, 225)";
export const colorTurvaNude500 = "rgb(165, 122, 101)";
export const colorTurvaNude600 = "rgb(140, 98, 79)";
export const colorTurvaNude700 = "rgb(114, 76, 60)";
export const colorTurvaNude800 = "rgb(89, 56, 43)";
export const colorTurvaNude900 = "rgb(64, 38, 28)";
export const colorTurvaRed00 = "rgb(255, 241, 241)";
export const colorTurvaRed100 = "rgb(255, 213, 215)";
export const colorTurvaRed1000 = "rgb(51, 5, 20)";
export const colorTurvaRed200 = "rgb(255, 185, 190)";
export const colorTurvaRed300 = "rgb(252, 148, 158)";
export const colorTurvaRed400 = "rgb(240, 102, 119)";
export const colorTurvaRed50 = "rgb(255, 227, 228)";
export const colorTurvaRed500 = "rgb(221, 49, 77)";
export const colorTurvaRed600 = "rgb(198, 12, 48)";
export const colorTurvaRed700 = "rgb(164, 4, 40)";
export const colorTurvaRed800 = "rgb(126, 2, 35)";
export const colorTurvaRed900 = "rgb(87, 4, 29)";
export const colorWarning = "rgb(247, 178, 40)";
export const colorWarning00 = "rgb(255, 251, 242)";
export const colorWarning100 = "rgb(255, 244, 198)";
export const colorWarning1000 = "rgb(38, 26, 4)";
export const colorWarning200 = "rgb(255, 232, 160)";
export const colorWarning300 = "rgb(255, 217, 120)";
export const colorWarning400 = "rgb(255, 199, 79)";
export const colorWarning50 = "rgb(255, 247, 221)";
export const colorWarning500 = "rgb(247, 178, 40)";
export const colorWarning600 = "rgb(196, 138, 23)";
export const colorWarning700 = "rgb(156, 110, 22)";
export const colorWarning800 = "rgb(126, 87, 16)";
export const colorWarning900 = "rgb(81, 55, 9)";
export const colorWarningTurva = "rgb(247, 178, 40)";
export const fontFamilyHeading = "'localtapiola-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontFamilyHeadingTurva = "'turva-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontFamilyText = "'localtapiola-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontFamilyTextTurva = "'turva-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontSizeLarge = "1.25rem";
export const fontSizeMedium = "1rem";
export const fontSizeSmall = "0.875rem";
export const fontSizeXLarge = "1.5rem";
export const fontSizeXSmall = "0.75rem";
export const fontSizeXxLarge = "2.25rem";
export const fontSizeXxxLarge = "3rem";
export const fontSizeXxxxLarge = "4.5rem";
export const fontWeightBold = "700";
export const fontWeightExtraBold = "800";
export const fontWeightNormal = "400";
export const fontWeightSemiBold = "600";
export const letterSpacingHeading = "-0.01rem";
export const lineHeightMedium = "1.5";
export const lineHeightSmall = "1.25";
export const lineHeightXSmall = "1.1";
export const mediaQueryLarge = "'(min-width: 62em)'";
export const mediaQueryMedium = "'(min-width: 48em)'";
export const mediaQuerySmall = "'(min-width: 36em)'";
export const mediaQueryXLarge = "'(min-width: 64.0625em)'";
export const mediaQueryXSmall = "'(max-width: 35.9375em)'";
export const mediaQueryXxLarge = "'(min-width: 76.25em)'";
export const mediaQueryXxSmall = "'(max-width: 22.5em)'";
export const mediaQueryXxxLarge = "'(min-width: 106.25em)'";
export const mediaQueryXxxSmall = "'(max-width: 20.5em)'";
export const opacity30 = "0.30";
export const opacity50 = "0.50";
export const opacity75 = "0.75";
export const opacity85 = "0.85";
export const radiusCircle = "50%";
export const radiusDefault = "4px";
export const radiusIntermediate = "12px";
export const radiusLarge = "16px";
export const radiusMedium = "8px";
export const radiusPill = "20rem";
export const radiusSharp = "0";
export const shadowCard = "0 2px 6px 0 rgba(0, 41, 77, 0.07), 0 -1px 0 0 rgba(0, 0, 0, 0.09), -1px 0 0 0 rgba(0, 0, 0, 0.07), 1px 0 0 0 rgba(0, 0, 0, 0.07), 0 1px 0 0 rgba(0, 0, 0, 0.07)";
export const shadowCardTurva = "0 2px 6px 0 rgba(117, 117, 117, 0.13), 0 -1px 0 0 rgba(0, 0, 0, 0.09), -1px 0 0 0 rgba(0, 0, 0, 0.07), 1px 0 0 0 rgba(0, 0, 0, 0.07), 0 1px 0 0 rgba(0, 0, 0, 0.07)";
export const shadowDefault = "0 2px 6px 0 rgba(0, 41, 77, 0.07)";
export const shadowDefaultTurva = "0 2px 6px 0 rgba(117, 117, 117, 0.13)";
export const shadowError = "0 0 0 1px #de2362";
export const shadowErrorTurva = "0 0 0 1px #e55039";
export const shadowFocus = "0 0 0 4px rgba(0, 119, 179, 0.3), 0 0 0 1px #0077b3";
export const shadowFocusInput = "0 0 0 1px #0077b3";
export const shadowFocusInputTurva = "0 0 0 1px #171c3a";
export const shadowFocusTurva = "0 0 0 4px rgba(23, 28, 58, 0.2), 0 0 0 1px #171c3a";
export const shadowHover = "0 2px 10px 0 rgba(0, 41, 77, 0.1)";
export const shadowHoverInput = "0 0 0 1px #909599";
export const shadowHoverInputTurva = "0 0 0 1px #747475";
export const shadowHoverTurva = "0 2px 10px 0 rgba(117, 117, 117, 0.15)";
export const shadowModal = "0 2px 20px 0 rgba(0, 0, 0, 0.2)";
export const shadowTooltip = "0 2px 10px 0 rgba(0, 41, 77, 0.07)";
export const shadowTooltipTurva = "0 2px 10px 0 rgba(117, 117, 117, 0.13)";
export const sizeButtonBorder = "1px";
export const sizeButtonMinWidth = "8rem";
export const sizeButtonTinyBorder = "1px";
export const sizeFormBorder = "1px";
export const sizeHeader = "4rem";
export const sizeIconLarge = "30px";
export const sizeIconMedium = "24px";
export const sizeIconSmall = "20px";
export const sizeIconXLarge = "36px";
export const sizeIconXSmall = "16px";
export const sizeIconXxLarge = "48px";
export const sizeIconXxSmall = "10px";
export const sizeIconXxxLarge = "72px";
export const sizeIconXxxSmall = "7px";
export const sizeLayoutMaxWidth = "1110px";
export const sizeMediumBorder = "2px";
export const sizeNavigation = "3rem";
export const sizeStepMedium = "40px";
export const sizeStepSmall = "30px";
export const sizeTappableSquare = "48px";
export const spaceLarge = "20px";
export const spaceMedium = "16px";
export const spaceSmall = "12px";
export const spaceXLarge = "28px";
export const spaceXSmall = "8px";
export const spaceXxLarge = "36px";
export const spaceXxSmall = "4px";
export const spaceXxxLarge = "48px";
export const spaceXxxSmall = "2px";
export const spaceXxxxLarge = "72px";
export const spaceXxxxxLarge = "94px";
export const transitionQuickly = "300ms ease";
export const transitionSlowly = "600ms ease";
export const zIndexDeep = "-999999";
export const zIndexDefault = "1";
export const zIndexDropdown = "600";
export const zIndexHeader = "400";
export const zIndexMask = "200";
export const zIndexMaskButtons = "250";
export const zIndexMasked = "100";
export const zIndexModal = "900";
export const zIndexOverlay = "700";
export const zIndexPopup = "950";
export const zIndexSpinner = "800";
export const zIndexSticky = "300";
export const zIndexToast = "500";